export default {
  data() {
    return {
      simpleCategory: [
        {
          title: 'สินค้าทั้งหมด',
          slug: 'all'
        },
        {
          title: 'สินค้าขายดี',
          slug: 'bestsale'
        },
        {
          title: 'รวมสินค้ามาใหม่',
          slug: 'new'
        },
        {
          title: 'ผลไม้สดจากสวน',
          slug: 'fruit'
        },
        {
          title: 'อร่อยทั่วไทย',
          slug: 'thaifood'
        },
        {
          title: 'สินค้าไปรษณีย์',
          slug: 'postemart'
        },
        {
          title: 'หนังสือ',
          slug: 'book'
        },
        {
          title: 'สุขภาพและความงาม',
          slug: 'beauty'
        },
        {
          title: 'บ้านและสวน',
          slug: 'decoration'
        },
        {
          title: 'สินค้าชุมชน',
          slug: 'local'
        },
        {
          title: 'ขายยกลัง',
          slug: 'wholesale'
        },
        {
          title: 'วัตถุมงคล',
          slug: 'thaiamulets'
        },
        {
          title: 'เครื่องแต่งกาย',
          slug: 'clothing'
        },
        {
          title: 'ท่องเที่ยวและกีฬา',
          slug: 'travel'
        },
        {
          title: 'แม่และเด็ก',
          slug: 'mother'
        },
        {
          title: 'สินค้าอิเล็กทรอนิกส์/เครื่องใช้ไฟฟ้า',
          slug: 'electronics'
        },
        {
          title: 'โปรโมชั่น',
          slug: 'promotion'
        }
      ],
      productAll: [
        {
          sku: '1013500000021',
          product_title: 'ฟ้าละลายโจร ทดสอบ',
          product_thumb:
            'https://uat.thailandpostmart.com/files/product_thumb/20210720123221.png',
          product_price: '500',
          product_sale_net: '370'
        },
        {
          sku: '1013450001014',
          product_title:
            'น้ำปลาร้า ตรา "พานัว" สูตรนัวเบา ๆ 350 มล.  (แพคละ 12 ขวด) - DEMO',
          product_thumb:
            'https://uat.thailandpostmart.com/files/thumbnail_pixel.png',
          product_price: '460',
          product_sale_net: '460'
        },
        {
          sku: '1013460000221',
          product_title: 'test ปณ',
          product_thumb:
            'https://uat.thailandpostmart.com/files/thumbnail_pixel.png',
          product_price: '3',
          product_sale_net: '3'
        },
        {
          sku: '1013450001010',
          product_title: 'ไข่แดงเค็มรสน้ำผึ้ง TEST',
          product_thumb:
            'https://uat.thailandpostmart.com/files/product_thumb/20210623130958.png',
          product_price: '2000',
          product_sale_net: '1200'
        },
        {
          sku: '1013450001009',
          product_title: 'สินค้าทดสอบโครงสร้างราคาอัตโนมัติ - Keng SHOP',
          product_thumb:
            'https://uat.thailandpostmart.com/files/product_thumb/20210623125115.png',
          product_price: '2000',
          product_sale_net: '1200'
        },
        {
          sku: '1013450001008',
          product_title: 'น้ำพริกเผาโฮมเมดสูตรหมูสับ (1 ชุดมี 2 กระปุก)',
          product_thumb:
            'https://uat.thailandpostmart.com/files/thumbnail_pixel.png',
          product_price: '300',
          product_sale_net: '300'
        },
        {
          sku: '1013450001006',
          product_title: 'กุนเชียงหมูอย่างดี',
          product_thumb:
            'https://uat.thailandpostmart.com/files/product_thumb/20210622155250.png',
          product_price: '290',
          product_sale_net: '290'
        },
        {
          sku: '1013450001005',
          product_title: 'กุนเชียงปลากรายแท้',
          product_thumb:
            'https://uat.thailandpostmart.com/files/product_thumb/20210622154958.png',
          product_price: '300',
          product_sale_net: '300'
        },
        {
          sku: '1013450001004',
          product_title: 'ไข่แดงเค็มรสน้ำผึ้งพรีเมี่ยม',
          product_thumb:
            'https://uat.thailandpostmart.com/files/product_thumb/20210622154712.png',
          product_price: '125',
          product_sale_net: '125'
        },
        {
          sku: '1013450001003',
          product_title: 'ปลาหมึกแห้งหอมหมื่นลี้',
          product_thumb:
            'https://uat.thailandpostmart.com/files/product_thumb/20210622105735.png',
          product_price: '179',
          product_sale_net: '179'
        },
        {
          sku: '1013450001002',
          product_title: 'หมี่กรอบน้ำสับปะรด (1 ชุดมี 2 กระปุก)',
          product_thumb:
            'https://uat.thailandpostmart.com/files/product_thumb/20210622100830.png',
          product_price: '150',
          product_sale_net: '410'
        },
        {
          sku: '1013450001001',
          product_title: 'เนื้อแดดเดียว กล่อง (บรรจุ รสหวาน 2 ห่อ)',
          product_thumb:
            'https://uat.thailandpostmart.com/files/product_thumb/20210608141846.png',
          product_price: '300',
          product_sale_net: '300'
        },
        {
          sku: '1014210000141',
          product_title: 'มะนาวแป้นไซส์ใหญ่เบอร์ 0 (100 กก 500 ลูก)',
          product_thumb:
            'https://uat.thailandpostmart.com/files/product_thumb/20210608103142.png',
          product_price: '2300',
          product_sale_net: '2300'
        },
        {
          sku: '1013450001000',
          product_title: '(ทดสอบ) หมี่กรอบ รสต่าง ๆ',
          product_thumb:
            'https://uat.thailandpostmart.com/files/product_thumb/20210525082200.png',
          product_price: '100',
          product_sale_net: '110'
        },
        {
          sku: '1013980000048',
          product_title:
            'ทดสอบ Set 2 ชุดเซท Mc Protective Unisex เสื้อแจ็คเก็ต พร้อมกางเกงเข้าชุด สีกรมท่า MAVZ001',
          product_thumb:
            'https://uat.thailandpostmart.com/files/product_thumb/20210524111938.png',
          product_price: '1095',
          product_sale_net: '1070'
        },
        {
          sku: '1013450000996',
          product_title: 'กล้วยเบรคแตกอบแห้ง 400 กรัม',
          product_thumb:
            'https://uat.thailandpostmart.com/files/product_thumb/20210519212828.png',
          product_price: '105',
          product_sale_net: '105'
        },
        {
          sku: '1013450000995',
          product_title:
            'เมล่อนญี่ปุ่น เกรดA ชุดครอบครัว โปรโมชั่น ซื้อ1แถม1 6x2 ผล รวม12ผล',
          product_thumb:
            'https://uat.thailandpostmart.com/files/product_thumb/20210519212159.png',
          product_price: '2700',
          product_sale_net: '2700'
        },
        {
          sku: '1013450000994',
          product_title:
            'เพิร์ลเมล่อนเนื้อส้ม คัดพิเศษ พร้อมกล่องชุด 1 ผล (ซื้อ2กล่อง แถม1กล่อง)',
          product_thumb:
            'https://uat.thailandpostmart.com/files/product_thumb/20210519211325.png',
          product_price: '599',
          product_sale_net: '599'
        },
        {
          sku: '1013450000993',
          product_title: 'ส้มสายน้ำผึ้ง สวนส้มธนาธร บรรจุกล่องพร้อมจำหน่าย',
          product_thumb:
            'https://uat.thailandpostmart.com/files/product_thumb/20210519210643.png',
          product_price: '490',
          product_sale_net: '480'
        },
        {
          sku: '1013450000992',
          product_title: 'ลิ้นจี่ พันธุ์ฮงฮวย 5 กิโล',
          product_thumb:
            'https://uat.thailandpostmart.com/files/product_thumb/20210519210159.png',
          product_price: '520',
          product_sale_net: '490'
        },
        {
          sku: '1013450000991',
          product_title: 'สินค้าทดสอบชุมชนยิ้มได้--01',
          product_thumb:
            'https://uat.thailandpostmart.com/files/product_thumb/20210524140844.png',
          product_price: '170',
          product_sale_net: '170'
        },
        {
          sku: '1013450000989',
          product_title: 'test',
          product_thumb:
            'https://uat.thailandpostmart.com/files/thumbnail_pixel.png',
          product_price: '100',
          product_sale_net: '100'
        },
        {
          sku: '1013450000987',
          product_title: 'แคบหมูติดมันกระเทียมเจียวหอม TesT DEVvv',
          product_thumb:
            'https://uat.thailandpostmart.com/files/product_thumb/20210401111720.png',
          product_price: '145',
          product_sale_net: '145'
        },
        {
          sku: '1013980000047',
          product_title: 'ก็อกๆ',
          product_thumb:
            'https://uat.thailandpostmart.com/files/thumbnail_pixel.png',
          product_price: '200',
          product_sale_net: '200'
        }
      ]
    }
  }
}
